// Base
import Link from 'next/link'
import Image from 'next/image'
import { UrlObject } from 'url'

// Components
import { Box } from 'yard-utilities/components'

interface BackButtonProps {
  href?: string | UrlObject
  onClick?: () => void
}

const BackButton = ({ href, onClick }: BackButtonProps) => {
  return (
    <Box spacing={{ sm: 16 }}>
      <BackButtonWrapper href={href} onClick={onClick}>
        <Image
          src="/images/v21/icons/arrow-back.svg"
          width={32}
          height={32}
          alt="back arrow icon"
        />
      </BackButtonWrapper>
    </Box>
  )
}

interface BackButtonWrapperProps {
  href?: string | UrlObject
  onClick?: () => void
  children: React.ReactNode
}

const BackButtonWrapper = ({
  href,
  onClick,
  children
}: BackButtonWrapperProps) => {
  if (href) {
    return <Link href={href}>{children}</Link>
  }

  return (
    <div onClick={onClick} role="button" style={{ display: 'inline-block ' }}>
      {children}
    </div>
  )
}

export default BackButton
